module.exports = __webpack_public_path__ + "img/lock.acd54ad6.png";